/**
 * PSTUDIO-3602 — persistence for the "Auto-renumber pasted nodes" toggle.
 * Kept as a tiny pure module (no MobX/store imports) so the localStorage
 * contract can be unit-tested in isolation. Default is Smart (true), matching
 * the shipped pre-3602 paste behaviour and Mostafa's mockup.
 */
export const AUTO_RENUMBER_ON_PASTE_STORAGE_KEY = 'ps-auto-renumber-on-paste';

export function loadAutoRenumberOnPaste(): boolean {
  try {
    const raw = localStorage.getItem(AUTO_RENUMBER_ON_PASTE_STORAGE_KEY);
    if (raw === 'false') return false;
    if (raw === 'true') return true;
    return true; // unset or corrupt → default Smart
  } catch {
    return true;
  }
}

export function persistAutoRenumberOnPaste(value: boolean): void {
  try {
    localStorage.setItem(
      AUTO_RENUMBER_ON_PASTE_STORAGE_KEY,
      value ? 'true' : 'false'
    );
  } catch {
    // localStorage unavailable (private mode / denied) — non-fatal; the
    // in-memory observable still drives this session.
  }
}
